import { HeaderComponent } from './HeaderComponent';

export default HeaderComponent;